<template>
  <v-textarea
  v-if="!outlinedNormal && !soloNormal"
  v-model="model"
  :rules="rules"
  :class="`sts-web-system-label ${special ? 'special' : ''} ${disabled ? 'v-input--is-readonly' : ''}`"
  :disabled="disabled"
  :label="$t(label)"
  :style="`${width ? `width: ${width};` : ''}`"
  :readonly="readonly"
  :height="height ? height : 100">
  </v-textarea>
  <v-textarea
  v-else-if="outlinedNormal"
  v-model="model"
  :rules="rules"
  :class="`sts-web-system-label normal-text-field ${special ? 'special' : ''} ${disabled ? 'v-input--is-readonly' : ''}`"
  :disabled="disabled"
  :readonly="readonly"
  outlined
  :style="`${width ? `width: ${width};` : ''}`"
  hide-details="auto"
  dense
  :no-resize="noResize"
  :label="$t(label)"
  :height="height ? height : 100">
  </v-textarea>
  <v-textarea
  v-else-if="soloNormal"
  v-model="model"
  :rules="rules"
  :class="`sts-web-system-label normal-text-field ${special ? 'special' : ''} ${disabled ? 'v-input--is-readonly' : ''}`"
  :style="`${width ? `width: ${width};` : ''}`"
  :disabled="disabled"
  :readonly="readonly"
  solo
  flat
  hide-details="auto"
  dense
  :no-resize="noResize"
  :label="$t(label)"
  :height="height ? height : 100">
  </v-textarea>
</template>
<script>
export default {
  props: {
    icon: Boolean,
    required: Boolean,
    label: String,
    height: [String, Number],
    value: String,
    disabled: Boolean,
    outlinedNormal: Boolean,
    soloNormal: Boolean,
    noResize: Boolean,
    readonly: Boolean,
    min: {
      type: Number,
      default: () => {
        return null
      }
    },
    max: {
      type: Number,
      default: () => {
        return null
      }
    },
    special: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    width: {
      type: String,
      default: () => {
        return null
      }
    }
  },
  model: {
    prop: 'value',
    event: 'valueChanged'
  },
  computed: {
    model: {
      get: function() {
        return this.$props.value
      },
      set: function(v) {
        this.$emit('valueChanged', v)
      }
    }
  },
  data() {
    return {
      rules: [
        (v) => this.required ? !!v || this.$t('invalidValue.required') : true,
        (v) => {
          if (v !== null && v !== null && this.max) {
            return  String(v).length <= this.max || this.$t('invalidValue.maxSymbols', {'value': this.max})
          }
          return true
        },
        (v) => {
          if (v !== null && v !== null && this.min) {
            return  String(v).length >= this.min || this.$t('invalidValue.minSymbols', {'value': this.min})
          }
          return true
        }
      ]
    }
  }
}
</script>
<style>
.sts-web-system-label  .v-label.theme--light {
  font-family: 'Titillium Web', sans-serif;
  font-weight: 300;
}
.sts-web-system-label {
  font-family: 'Titillium Web', sans-serif;
  font-weight: 300;
}

.sts-web-system-label  > div.v-input__control > div.v-input__slot > div.v-text-field__slot > textarea {
  font-family: 'Titillium Web', sans-serif;
  font-weight: 300;
  color: black;
}
</style>